import React, {useCallback, useState} from 'react';
import {Button, Container, Col, Row} from 'reactstrap';
import ReactMarkdown from 'react-markdown';
import classNames from 'classnames';
import {bonus} from './data.json';
import './BonusList.scss';

function BonusItem({id, number, owner, value, title, description, image, ...props}) {
  return (
    <div className="bonus">
      <Container className="p-0" fluid>
        <Row className="d-flex align-items-center justify-content-center mb-3">
          {!image ? null : (
            <Col xs="10" lg="2" className="mb-4 mb-lg-0">
              <p className="text-center mb-0">
                <img className="bonus-img img-fluid mx-auto" src={image} />
              </p>
            </Col>
          )}
          <Col xs="12" lg={!image ? '12' : '10'}>
            <h3 className="text-condensed text-800 text-center text-lg-left mb-0">Bonus #{number}</h3>
            <h3 className="text-condensed text-800 text-center text-lg-left mb-2">{title}</h3>
            {!owner ? null : (
              <p className="text-center text-lg-left mb-0">
                From {owner}
                {value ? (
                  <>
                    {' '}
                    &mdash; <strong>Value: ${value}</strong>
                  </>
                ) : null}
              </p>
            )}
          </Col>
        </Row>
        <Row>
          <Col>
            <ReactMarkdown className="bonus-description" source={description} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

BonusItem.defaultProps = {};

export default function BonusList({id, ...props}) {
  return bonus.map((bonus) => <BonusItem {...bonus} key={bonus.id} />);
}
